import { render, staticRenderFns } from "./PatientSelector.vue?vue&type=template&id=2bf63259&scoped=true"
import script from "./PatientSelector.vue?vue&type=script&lang=js"
export * from "./PatientSelector.vue?vue&type=script&lang=js"
import style0 from "./PatientSelector.vue?vue&type=style&index=0&id=2bf63259&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2bf63259",
  null
  
)

export default component.exports